var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Application } from 'vevet';
var defaultProps = {
    shouldPrintVersion: true,
    tablet: 1199,
    phone: 899,
    resizeDebounce: 30,
    easing: [0.25, 0.1, 0.25, 1],
    shouldCheckWebpSupport: true,
    widthDetection: 'boundingRect',
};
var overrideProps = typeof window !== 'undefined' && 'vevetProps' in window
    ? window.vevetProps
    : {};
var props = __assign(__assign({}, defaultProps), overrideProps);
export var vevet = (typeof window !== 'undefined'
    ? new Application(__assign(__assign({}, props), { prefix: 'v-' }))
    : undefined);
export * from 'vevet';
//# sourceMappingURL=index.js.map